import React from 'react';
import { useSelector } from 'react-redux';
import { Quotes } from '@yme/assets/icons';
import { Col, Container, Row } from '@yme/atoms/grid';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
import { getFormattedQuoteAuthor } from './helpers';
import { AuthorStyled, IconStyled, QuoteContainerStyled } from './styled';
export function Quote(props) {
    const { author, text, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    const formattedAuthor = getFormattedQuoteAuthor(author);
    if (text) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Container, { dataTestId: "quote", isRightToLeft: isRightToLeft },
                React.createElement(Row, { justifyContent: "center" },
                    React.createElement(Col, { lg: 6, md: 8, sm: 4 },
                        React.createElement(QuoteContainerStyled, { isRightToLeft: isRightToLeft },
                            React.createElement(IconStyled, { isRightToLeft: isRightToLeft },
                                React.createElement(SVGIcon, { type: Quotes, size: ICON_SIZE.xm })),
                            React.createElement(RegularTextLevel2, null, text),
                            formattedAuthor && (React.createElement(AuthorStyled, null,
                                React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, formattedAuthor)))))))));
    }
    return null;
}
Quote.displayName = 'Quote_AEMComponent';
